<kion-brand-logo [baseSite$]="baseSite$"></kion-brand-logo>
